<div class="bg-white shadow-sm hover:border-slate-300 hover:shadow-md transition-all">
  <div class="p-4">
    <h5 class="mb-4 text-slate-700 text-lg font-semibold">
      <mat-icon class="align-top">oil_barrel</mat-icon>
      Fracs
    </h5>

    <table mat-table [dataSource]="dataSource" class="table-auto w-full border-collapse border-spacing-3">
      <ng-container matColumnDef="fracID">
        <th mat-header-cell *matHeaderCellDef class="text-center py-3 px-4 text-sm font-semibold">ID</th>
        <td mat-cell *matCellDef="let element" class="py-2 px-3">{{ element.fracID }}</td>
      </ng-container>

      <ng-container matColumnDef="fracName">
        <th mat-header-cell *matHeaderCellDef class="py-3 px-4 text-sm font-semibold">Frac Name</th>
        <td mat-cell *matCellDef="let element" class="py-2 px-3">{{ element.fracName }}</td>
      </ng-container>

      <ng-container matColumnDef="waitTime">
        <th mat-header-cell *matHeaderCellDef class="text-center py-3 px-4 text-sm font-semibold">Wait Time</th>
        <td mat-cell *matCellDef="let element" class="py-2 px-3">{{ element.waitTime }}</td>
      </ng-container>

      <ng-container matColumnDef="currentStage">
        <th mat-header-cell *matHeaderCellDef class="text-center py-3 px-4 text-sm font-semibold">Current Stage</th>
        <td mat-cell *matCellDef="let element" class="py-2 px-3">{{ element.currentStage | number }}</td>
      </ng-container>

      <ng-container matColumnDef="totalStages">
        <th mat-header-cell *matHeaderCellDef class="text-center py-3 px-4 text-sm font-semibold">Total Stages</th>
        <td mat-cell *matCellDef="let element" class="py-2 px-3">{{ element.totalStages | number }}</td>
      </ng-container>

      <ng-container matColumnDef="trucksOnLocation">
        <th mat-header-cell *matHeaderCellDef class="text-center py-3 px-4 text-sm font-semibold">
          Trucks on Location
        </th>
        <td mat-cell *matCellDef="let element" class="py-2 px-3">
          {{ element.trucksOnLocation | number }}
        </td>
      </ng-container>

      <ng-container matColumnDef="loadsInProgress">
        <th mat-header-cell *matHeaderCellDef class="text-center py-3 px-4 text-sm font-semibold">Loads in Progress</th>
        <td mat-cell *matCellDef="let element" class="py-2 px-3">{{ element.loadsInProgress | number }}</td>
      </ng-container>

      <ng-container matColumnDef="plannedPumpAmount">
        <th mat-header-cell *matHeaderCellDef class="text-center py-3 px-4 text-sm font-semibold">Planned</th>
        <td mat-cell *matCellDef="let element" class="py-2 px-3">
          {{ element.plannedPumpAmount | number }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actualPumpedAmount">
        <th mat-header-cell *matHeaderCellDef class="text-center py-3 px-4 text-sm font-semibold">Actual</th>
        <td mat-cell *matCellDef="let element" class="py-2 px-3">
          {{ element.actualPumpedAmount | number }}
        </td>
      </ng-container>

      <ng-container matColumnDef="percentageDifference">
        <th mat-header-cell *matHeaderCellDef class="text-center py-3 px-4 text-sm font-semibold">Fulfilment (%)</th>
        <td mat-cell *matCellDef="let element" class="py-2 px-3">
          {{ calculatePercentage(element.actualPumpedAmount, element.plannedPumpAmount) | number: '1.2-2' }} %
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="border-b"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="hover:bg-gray-50 transition-colors"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center" colspan="10">No data</td>
      </tr>
    </table>
  </div>
</div>
